module.exports = __webpack_public_path__ + "static/media/request_guidance.9327cdc7.gif";